import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the Filter Bets Report View.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing a date picker
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Makes the input read-only
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center left section (currently empty)
        const center_left = {
            margin: 5,
            rows: [],
        };

        // Center right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Right section containing a state selection dropdown
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting state
                    name: 'State',
                    localId: 'bonusStates:combo', // Local ID for reference
                    label: _("<span class='icon-state'></span> Estado"), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        {
                            id: '',
                            value: 'Todos', // Option for all states
                        },
                        {
                            id: 'A',
                            value: 'Activo', // Option for active state
                        },
                        {
                            id: 'I',
                            value: 'Inactivo', // Option for inactive state
                        },
                    ],
                },
            ],
        };

        // Upper section combining left and right sections
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Buttons section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Rows of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
